import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"height":"440px","overflow-y":"scroll"} }


import { ref, defineExpose, computed, unref, defineEmits } from 'vue'
import { ElDialog, ElButton, ElDropdown, ElDropdownMenu, ElDropdownItem, ElIcon, ElMessage } from 'element-plus'
import { ArrowDown, RemoveFilled } from '@element-plus/icons-vue'
const __default__ = {
  name: 'ImportData'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['on-submit'],
  setup(__props, { expose: __expose, emit: __emit }) {

const dialogVisible = ref(false)
const graphJsonStr = ref('')
// 定义外部事件
const emits = __emit
// 显示，由父组件调用
const show = () => {
  dialogVisible.value = true
}
const refreshFlag = ref(1)
// 本地保存数据
const localStorageLfData = computed(() => {
  const res : any = []
  if (refreshFlag.value > 0) {
    Object.keys(window.localStorage).forEach(key => {
      if (key.startsWith('LFDATA###')) {
        const arr = key.split('###')
        res.push({
          value: key,
          label: arr[2]
        })
      }
    })
  }
  return res
})
// 处理确定按钮事件
const handleSubmit = () => {
  if (unref(graphJsonStr)) {
    emits('on-submit', unref(graphJsonStr))
    dialogVisible.value = false
  } else {
    ElMessage.error('导入数据不能为空')
  }
}
// 处理导入选项选中事件
const handleCommand = (key: string) => {
  graphJsonStr.value = window.localStorage.getItem(key) || ''
}
// 处理删除事件
const handleRemove = (key: string) => {
  window.localStorage.removeItem(key)
  refreshFlag.value++
}
const handleClose = () => {
  dialogVisible.value = false
  graphJsonStr.value = ''
}
/**
 * 刷新
 */
const refresh = () => {
  refreshFlag.value++
}
__expose({
  show,
  refresh
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    title: "导入流程数据(同时支持xml/json)",
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    width: "60%",
    onClose: handleClose,
    "custom-class": "m-dialog-import-data",
    "append-to-body": true
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(ElButton), { onClick: handleClose }, {
        default: _withCtx(() => [
          _createTextVNode("取 消")
        ]),
        _: 1
      }),
      _createVNode(_unref(ElButton), {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode("确 定")
        ]),
        _: 1
      }),
      (localStorageLfData.value.length)
        ? (_openBlock(), _createBlock(_unref(ElDropdown), {
            key: 0,
            placement: "top",
            trigger: "click",
            style: {"float":"left"},
            onCommand: handleCommand
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_unref(ElDropdownMenu), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localStorageLfData.value, (item) => {
                    return (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                      key: item.value,
                      command: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label) + "   ", 1),
                        _createVNode(_unref(ElIcon), {
                          onClick: ($event: any) => (handleRemove(item.value))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(RemoveFilled))
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["command"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(ElButton), {
                link: "",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("选择"),
                  _createVNode(_unref(ElIcon), { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowDown))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_input, {
          modelValue: graphJsonStr.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((graphJsonStr).value = $event)),
          rows: 20,
          type: "textarea"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})